import {alpha, createTheme} from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: 'Lato-Regular, Arial',
    },
    palette: {
        main: '#FFFFFF',
        fontTheme: {
            main: '#003366',
            light: alpha('#003366', 0.5)
        } 
    },
    components: {
    MuiButton: {
        styleOverrides: {
            root: {
                border: '2px solid',
                fontWeight: 'bold',
                color: '#003366',
                '&:hover': {
                    backgroundColor: '#003366',
                    color: 'white'
                }
            }
        }
    },
    MuiTableCell: {
        styleOverrides: {
            root: {
                textAlign: 'left',
                padding: '0px'
            }
        }
    },
    MuiBackdrop: {
        styleOverrides: {
          root: {
                '&[style*="opacity: 0"]': {
                pointerEvents: 'none',
                },
            },
        },
    },
    MuiSwitch: {
      styleOverrides: {
        switchBase: {
          color: "#003366"
        },
        colorPrimary: {
          "&.Mui-checked": {
            color: "#09AC1C"
          }
        },
        track: {
          backgroundColor: "#FFFFFF",
          opacity: 1,
          ".Mui-checked.Mui-checked + &": {
            backgroundColor: "#09AC1C58"
          }
        }
      }
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: ({ theme }) => ({
          fontSize: '16px',
          [theme.breakpoints.down('xl')]: {
            fontSize: '14px'
          }
        })
      }
    }
  }
});


export default theme;